import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=ff5245c8&scoped=true&"
import script from "./datepicker.vue?vue&type=script&lang=js&"
export * from "./datepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5245c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff5245c8')) {
      api.createRecord('ff5245c8', component.options)
    } else {
      api.reload('ff5245c8', component.options)
    }
    module.hot.accept("./datepicker.vue?vue&type=template&id=ff5245c8&scoped=true&", function () {
      api.rerender('ff5245c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/datepicker.vue"
export default component.exports